import PropTypes from 'prop-types';
import React, { useState, useMemo } from 'react';

import Button from '../Button';
import PageLayout from '../PageLayout';
import SmallSelectButton from '../SmallSelectButton';

export const QuestionPageLayout = ({
  id,
  value: initialValue,
  title,
  helpText,
  onSubmit,
  socialProofText,
}) => {
  const [value, setValue] = useState(initialValue);

  const isInvalid = useMemo(() => value === null, [value]);

  const handleClick = event => {
    setValue(event.target.value === 'true' || event.target.value === true);
  };

  const handleSubmit = event => {
    event.preventDefault();

    if (!isInvalid) {
      onSubmit(value);
    }
  };

  return (
    <PageLayout title={title} helpText={helpText} socialProofText={socialProofText}>
      <form onSubmit={handleSubmit}>
        <div className="row row--align-bottom-small">
          <div className="col col--auto">
            <SmallSelectButton
              selectButtonId={id}
              defaultCheckedButton={value}
              handleClick={handleClick}
            />
          </div>
        </div>
        <div className="mt-12">
          <Button type="submit" className="niso-button" isDisabled={isInvalid}>
            Next
          </Button>
        </div>
      </form>
    </PageLayout>
  );
};

QuestionPageLayout.propTypes = {
  id: PropTypes.string,
  title: PropTypes.string,
  value: PropTypes.bool,
  helpText: PropTypes.string,
  onSubmit: PropTypes.func.isRequired,
  socialProofText: PropTypes.arrayOf(PropTypes.string),
};

QuestionPageLayout.defaultProps = {
  id: 'select-button-id',
  title: '',
  value: null,
  helpText: null,
};

export default QuestionPageLayout;
